import { useQuery } from "@tanstack/react-query";
import { swingCollectionsService } from "../../../services/swingCollections";

export function useSwingCollection(collectionId) {
  const enabled = Boolean(collectionId && collectionId !== "");

  const { data, isFetching, isLoading, ...rest } = useQuery({
    enabled,
    queryKey: ["getSwingCollection_key", collectionId],
    retry: 1,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      if (!collectionId) return null;
      return swingCollectionsService.getSwingCollection({ collectionId });
    },
  });

  return {
    collection: data ?? null,
    isFetching: enabled ? isFetching : false,
    isLoading: enabled ? isLoading : false,
    ...rest,
  };
}
